module.exports = "https://cdn.realtymogul.com/static/media/icon_background.948b375c.svg";